import { useDispatch } from 'react-redux';
import useAppState from './useAppState';
import { ChatActions, setCompanyDomain } from '../reducers/chat';
export default function useChatSlice() {
  const state = useAppState();
  const dispatch = useDispatch();
  return {
    chat: state.chat,
    set: data => dispatch(ChatActions.set(data)),
    setCompanyDomain: companyDomain => dispatch(setCompanyDomain(companyDomain))
  };
}